import React from "react";
import { Notification as RANotification } from "react-admin";

const Notification = (props) => (
    <RANotification {...props} autoHideDuration={5000} />
);

export default Notification;
